import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SKIP_MAINTENANCE_INTERCEPTOR } from '@ebeihilfe/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IsHealthyService } from '../is-healthy/is-healthy.service';

@Injectable()
export class OfflineInterceptor implements HttpInterceptor {
  public constructor(
    private readonly router: Router,
    private readonly isHealtyService: IsHealthyService,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        //check if error type of service Unavailable and handle it
        if (
          error instanceof HttpErrorResponse &&
          (error.status === 0 || (error.status >= 500 && error.status < 600)) &&
          request.context.get(SKIP_MAINTENANCE_INTERCEPTOR) === false
        ) {
          this.router.navigateByUrl('offline');
          console.error(error.url, ' is offline');
          this.isHealtyService.setOffline();
          return of(new HttpResponse());
        }
        //error passed because handling is not needed
        return throwError(() => error);
      }),
    );
  }
}
